exports.isNumber = (evt) => {
    evt = evt ? evt : window.event;
    let charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
    } else {
        return true;
    }
};

exports.formatAmountToDollar = (amount, decimal, currency) => {
    if (amount === undefined) return;
    try {
        const value = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currency,
            minimumFractionDigits: decimal,
            currencyDisplay: "narrowSymbol",
        });
        return value.format(amount);
    } catch (e) {
        // Fallback for currencies that don't support narrowSymbol
        const symbol = exports.getCurrencySymbol(currency);
        const formattedNumber = new Intl.NumberFormat("en-US", {
            minimumFractionDigits: decimal,
            maximumFractionDigits: decimal,
        }).format(amount);
        return `${symbol}${formattedNumber}`;
    }
};

exports.getCurrencySymbol = (currency) => {
    const symbols = {
        USD: '$',
        NGN: '₦',
        GBP: '£',
        EUR: '€',
        KES: 'KSh',
        GHS: '₵',
        ZAR: 'R',
        CAD: 'C$',
        AUD: 'A$',
        JPY: '¥',
        CNY: '¥',
        INR: '₹',
        AED: 'د.إ',
        SAR: '﷼',
        CHF: 'CHF',
        SEK: 'kr',
        NOK: 'kr',
        DKK: 'kr',
        PLN: 'zł',
        BRL: 'R$',
        MXN: '$',
        SGD: 'S$',
        HKD: 'HK$',
        NZD: 'NZ$',
        TRY: '₺',
        RUB: '₽',
        KRW: '₩',
        THB: '฿',
        MYR: 'RM',
        PHP: '₱',
        IDR: 'Rp',
        VND: '₫',
        EGP: 'E£',
        PKR: '₨',
        BDT: '৳',
        LKR: '₨',
        NPR: '₨',
        TWD: 'NT$',
        COP: '$',
        CLP: '$',
        PEN: 'S/',
        ARS: '$',
        UGX: 'USh',
        TZS: 'TSh',
        RWF: 'FRw',
        XOF: 'CFA',
        XAF: 'FCFA',
        MAD: 'د.م.',
        BWP: 'P',
        MUR: '₨',
        ZMW: 'ZK',
    };
    return symbols[currency] || currency || '$';
};

exports.formatCompactAmount = (value, currency = 'USD') => {
    const symbol = exports.getCurrencySymbol(currency);
    if (value >= 1000000000) {
        return symbol + (value / 1000000000).toFixed(1) + 'B';
    } else if (value >= 1000000) {
        return symbol + (value / 1000000).toFixed(1) + 'M';
    } else if (value >= 1000) {
        return symbol + (value / 1000).toFixed(0) + 'K';
    }
    return symbol + value;
};

exports.formatToStringDate = (date) => {
    if (!date) return "";
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];
    let currentdate = new Date(date);

    let datetime =
        days[currentdate.getDay()] +
        ", " +
        currentdate.getDate() +
        " " +
        months[currentdate.getMonth()] +
        " " +
        currentdate.getFullYear();

    return datetime;
};

exports.formatISODate = (date) => {
    if (!date) return "";
    let currentdate = new Date(date);

    let datetime =
        currentdate.getDate() +
        "/" +
        (currentdate.getMonth() + 1) +
        "/" +
        currentdate.getFullYear();

    return datetime;
};

exports.formatISOTime = (date) => {
    return new Date(date).toLocaleString("en-US").split(",")[1];
};

exports.milliSecondsToDayHourMin = (timeRemaining) => {
    let dayInMilliseconds = 86400000;
    let hourInMilliseconds = 3600000;
    let day = Math.floor(timeRemaining / dayInMilliseconds);
    let hour = Math.floor(
        (timeRemaining - day * dayInMilliseconds) / hourInMilliseconds
    );
    let min = Math.round(
        (timeRemaining - day * dayInMilliseconds - hour * hourInMilliseconds) /
        60000
    );
    let seconds = Math.round(timeRemaining - min / 60);
    const pad = function(num) {
        return num < 10 ? "0" + num : num;
    };
    if (min === 60) {
        hour++;
        min = 0;
    }
    if (hour === 24) {
        day++;
        hour = 0;
    }
    return `${day} : ${pad(hour)}  :  ${pad(min)}:  ${pad(seconds)}`;
};

exports.calculateDay = (time) => {
    let timeToMilliseconds = new Date(time).getTime();
    let currentTime = Date.now();
    let ellapsedTime = currentTime - timeToMilliseconds;
    const days = Math.floor(ellapsedTime / (1000 * 60 * 60 * 24));
    return days;
};

exports.calculateHour = (time) => {
    let timeToMilliseconds = new Date(time).getTime();
    let currentTime = Date.now();
    let ellapsedTime = currentTime - timeToMilliseconds;
    const hour = Math.floor(ellapsedTime / (1000 * 60 * 60)) % 24;
    return hour;
};

exports.calculateMin = (time) => {
    let timeToMilliseconds = new Date(time).getTime();
    let currentTime = Date.now();
    let ellapsedTime = currentTime - timeToMilliseconds;
    const min = Math.floor(ellapsedTime / (1000 * 60)) % 60;
    return min;
};

exports.getTimeLeft = (countDownDate) => {
    const now = new Date().getTime();

    // Find the distance between now and the count down date
    const distance = countDownDate - now;
    if (distance < 0) return "EXPIRED";
    // Time calculations for days, hours, minutes and seconds
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    const pad = function(num) {
        return num < 10 ? "0" + num : num;
    };
    return `${days} : ${pad(hours)}  :  ${pad(minutes)}:  ${pad(seconds)}`;
};
exports.capitalizeEachWord = (string) => {
    if (!string) return;
    let words = string.split(" ").map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
    });
    return words.join(" ");
};

exports.abbreviate = (string) => {
    if (!string) return;
    let letters = string.split(" ").map((word) => {
        return word.charAt(0).toUpperCase();
    });
    return letters.join(" . ");
};

exports.capitalize = (string) => {
    if (!string) return;
    return string.charAt(0).toUpperCase() + string.slice(1);
};

exports.emailUrl = function() {
    let originUrl = null;
    switch (window.location.host) {
        case "founders.getequity.io":
            originUrl = "https://founders.getequity.io";
            break;
        case "dev--company-dealroom.netlify.app":
            originUrl = "https://dev--company-dealroom.netlify.app/";
            break;
        default:
            originUrl = "https://staging--company-dealroom.netlify.app";
            break;
    }
    return originUrl;
};

exports.truncate = (text, length) => {
    if (text.length > length) {
        return text.slice(0, length) + "...";
    } else {
        return text;
    }
};

exports.removeUnderscore = (value) => {
    if (!value) return "";
    if (!value.includes("_")) return value;
    const splitValue = value.split("_");
    if (splitValue.length === 1) return splitValue;
    return splitValue.join(" ");
};

exports.removeDash = (value) => {
    if (!value) return "";
    if (!value.includes("-")) return value;
    const splitValue = value.split("-");
    if (splitValue.length === 1) return splitValue;
    return splitValue.join(" ");
};

exports.getRandomColour = function() {
    const activityColours = [
        "#3C7CBC",
        "#00BB5D",
        "#F7B633",
        "#070E14",
        "#DA0A0A",
    ];
    const number = Math.floor(Math.random() * activityColours.length);
    return activityColours[number];
};

exports.convertToLocale = function(price) {
    const num = typeof price === 'string' ? parseFloat(price) : price;
    if (isNaN(num)) return price;
    return num.toLocaleString();
};

exports.blankString = function(str) {
    return !str || /^\s*$/.test(str);
};

exports.industries = [
    "Electronics",
    "Mining",
    "Music",
    "Manufacturing",
    "Energy",
    "News Media",
    "Entertainment",
    "Hospitality",
    "Health care",
    "Food",
    "Pharmaceutical",
    "Education",
    "Construction",
    "Agriculture",
    "Telecommunication",
    "Technology",
    "Computer and Technology",
    "Transport",
    "Aerospace",
    "Retail",
    "Financial Services",
];

exports.stages = [
    "Pre seed",
    "Seed",
    "Series A",
    "Series B",
    "Series C",
    "Series D",
    "Public",
];

exports.companyTypes = ["Public", "Private", "Non Profit"];